import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import { Link } from "react-router-dom";

import LanguageDropdown from "../../components/Common/TopbarDropdown/LanguageDropdown";
import NotificationDropdown from "../../components/Common/TopbarDropdown/NotificationDropdown";

//i18n
import { withTranslation } from "react-i18next";

import {
  Button,
  Popover,
  PopoverBody,
  Tooltip,
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Container,
  UncontrolledPopover,
} from "reactstrap";

//import images
import logoSm from "../../assets/images/logo-sm.png";
import logoDark from "../../assets/images/logo-dark.png";
import logoLight from "../../assets/images/logo-light.png";

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions";
import ProfileMenu from "../../components/Common/TopbarDropdown/ProfileMenu";
import AppsDropdown from "../../components/Common/TopbarDropdown/AppsDropdown";

import { useSelector, useDispatch } from "react-redux";
import { setForeground } from "../../store/data/actions";
import { collection, doc, onSnapshot, orderBy, query } from "firebase/firestore";
import { firestore } from "../../firebase";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Header = (props) => {


  const [search, setsearch] = useState(false);
  const [_foreground, setFore] = useState(false);
  const [tbottom, settbottom] = useState(false);
  const { currentCompany } = props;

  const dispatch = useDispatch(); // Aquí obtienes la función dispatch

  useEffect(() => {
    const customerId = currentCompany.id;
    const usersRef = doc(collection(firestore, 'users'), customerId);
    
    const unsubscribe = onSnapshot(usersRef, (docSnapshot) => {
      const userData = docSnapshot.data();
      const fore = userData?.primer_plano || false;
      dispatch(setForeground(fore));
    });

    return () => {
      unsubscribe();
    }
    
  }, [currentCompany]);


  useEffect(() => {
    setFore(props.foreground);
  }, [props.foreground]);



  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  function tToggle() {
    var body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  }

  return (
    <React.Fragment>

      <Tooltip
        placement="bottom"
        isOpen={tbottom}
        target="eye"
        toggle={() => {
          settbottom(!tbottom);
        }}
      >
        {_foreground ? 'Pantalla en Primer Plano' : 'TicketControl no se encuentra en Primer Plano en este momento o se encuentra minimizado'}
      
      </Tooltip>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">


            <div className="navbar-brand-box text-center">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logoSm} alt="logo-sm-dark" height="22" />
                </span>
                <span className="logo-lg">
 
                  <img src={logoDark} alt="logo-dark" height="24" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoSm} alt="logo-sm-light" height="36" />
                </span>
                <span className="logo-lg">
                  <img src={logoLight} alt="logo-light" height="36" />
                </span>
              </Link>
            </div>

            <button
              type="button"
              className="btn btn-sm px-3 font-size-24 header-item waves-effect"
              id="vertical-menu-btn"
              onClick={() => {
                tToggle();
              }}
            >
              <i className="ri-menu-2-line align-middle"></i>
            </button>

            {currentCompany?.id && (
              <div className="d-none d-md-flex align-items-center ms-3" style={{ overflow: "hidden" }}>
                <div style={{ lineHeight: 1.3 }}>
                  <div style={{ fontWeight: 600, fontSize: 14, whiteSpace: "nowrap" }}>
                    {currentCompany.name || ""}
                    {currentCompany.managerData?.isPro && (
                      <span className="badge bg-success ms-2" style={{ fontSize: 10, verticalAlign: "middle" }}>PRO</span>
                    )}
                  </div>
                  {(currentCompany.city || currentCompany.country) && (
                    <div style={{ fontSize: 11, color: "#888", whiteSpace: "nowrap" }}>
                      {[currentCompany.city, currentCompany.country].filter(Boolean).join(" • ")}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          <div className="d-flex">


            <div className="d-flex align-items-center">

              <span id='eye' className={`material-symbols-rounded ${_foreground ? "text-info" : "text-danger"}`} style={{ fontSize: 24 }}>{_foreground ? "visibility" : "visibility_off"}</span>

            </div>

{/* 
            <div className="dropdown d-inline-block d-lg-none ms-2">
              <button
                onClick={() => {
                  setsearch(!search);
                }}
                type="button"
                className="btn header-item noti-icon "
                id="page-header-search-dropdown"
              >
                <i className="ri-search-line" />
              </button>
              <div
                className={
                  search
                    ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                    : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                }
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="ri-search-line" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div> */}

            {/* <LanguageDropdown /> */}



            <AppsDropdown />

            <div className="dropdown d-none d-lg-inline-block ms-1">
              <button
                type="button"
                onClick={() => {
                  toggleFullscreen();
                }}
                className="btn header-item noti-icon"
                data-toggle="fullscreen"
              >
                <i className="ri-fullscreen-line" />
              </button>
            </div>
            {/* <NotificationDropdown /> */}

            <ProfileMenu />
            {/* 
            <div
              className="dropdown d-inline-block"
              onClick={() => {
                props.showRightSidebarAction(!props.showRightSidebar);
              }}
            >
              <button
                type="button"
                className="btn header-item noti-icon right-bar-toggle waves-effect"
              >
                <i className="mdi mdi-cog"></i>
              </button>
            </div> */}
          </div>
        </div>
      </header>

      {currentCompany?.id && (
        <div
          className="d-md-none"
          style={{
            position: "fixed",
            top: 70,
            left: 0,
            right: 0,
            zIndex: 999,
            background: "#fff",
            borderBottom: "1px solid #e9e9ef",
            padding: "4px 16px",
            height: 30,
            display: "flex",
            alignItems: "center",
          }}
        >
          <span style={{ fontWeight: 600, fontSize: 12, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            {currentCompany.name || ""}
            {currentCompany.managerData?.isPro && (
              <span className="badge bg-success ms-2" style={{ fontSize: 9, verticalAlign: "middle" }}>PRO</span>
            )}
          </span>
          {(currentCompany.city || currentCompany.country) && (
            <span style={{ fontSize: 10, color: "#888", marginLeft: 8, whiteSpace: "nowrap" }}>
              {[currentCompany.city, currentCompany.country].filter(Boolean).join(" • ")}
            </span>
          )}
        </div>
      )}
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout;
  const { foreground } = state.data
  const { currentCompany } = state.companies
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType, foreground, currentCompany };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));
